export default "__VITE_ASSET__592f1f0c__"